import { __extends } from "tslib";
import { SamplerState } from '../base/SamplerState';
var SamplerStateWebGL = /** @class */ (function (_super) {
    __extends(SamplerStateWebGL, _super);
    function SamplerStateWebGL() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SamplerStateWebGL;
}(SamplerState));
export { SamplerStateWebGL };
